module.exports = __webpack_public_path__ + "img/idcard_round.e498139e.svg";